import { Injectable } from '@angular/core'

import { Paginator } from '../../../shared/interfaces/paginator.interface'
import { CatalogueService } from '../../../shared/services/catalogue.service'
import { ToolUseCase } from '../../tools-catalogue/interfaces/tool-use-case.interface'
import { ToolUseCaseDto } from '../../tools-catalogue/resources/tool-use-case/dtos/tool-use-case.dto'
import { CatalogueResourceSlug } from '../enums/catalogue-resource-slug.enum'

@Injectable({
  providedIn: 'root'
})
export class ToolUseCaseService {
  constructor(private catalogueService: CatalogueService) {}

  list(listParams: {
    page?: number
    orderBy?: string
    countryIds?: number[]
    lifecycleIds?: number[]
    impactedStakeholderIds?: number[]
    purposeIds?: number[]
    targetSectorIds?: number[]
    targetUserIds?: number[]
    organisationIds?: number[]
    objectiveIds?: number[]
    toolIds?: number[]
    withoutPagination?: boolean
    terms?: string
    slug?: string
  }): Promise<Paginator<ToolUseCase> | ToolUseCase[]> {
    const params: { [key: string]: any } = Object.assign({}, listParams)

    if (listParams.withoutPagination) {
      params.withoutPagination = true
    } else {
      params.page = listParams.page ? listParams.page.toString() : '1'
    }
    if (listParams.orderBy) {
      if (listParams.orderBy === 'dateAsc') {
        params.orderBy = 'publishedAt'
      }
      if (listParams.orderBy === 'dateDesc') {
        params.orderBy = 'publishedAt'
        params.orderByDesc = true
      }
      if (listParams.orderBy === 'nameAsc') {
        params.orderBy = 'name'
      }
      if (listParams.orderBy === 'nameDesc') {
        params.orderBy = 'name'
        params.orderByDesc = true
      }
    }

    if (params.withoutPagination) {
      return this.catalogueService.list(
        CatalogueResourceSlug.ToolUseCases,
        params
      ) as Promise<ToolUseCase[]>
    } else {
      return (
        this.catalogueService.list(
          CatalogueResourceSlug.ToolUseCases,
          params
        ) as Promise<Paginator<ToolUseCase>>
      ).then((paginatorRes: Paginator<ToolUseCase>) =>
        Object.assign(
          paginatorRes,
          paginatorRes.data ? paginatorRes.data : { data: [] }
        )
      )
    }
  }
  listPaginated(listParams: {
    [key: string]: any
  }): Promise<Paginator<ToolUseCase>> {
    const params = Object.assign(
      {
        withoutPagination: false
      },
      listParams
    )

    return this.list(params) as Promise<Paginator<ToolUseCase>>
  }

  listUnpaginated(listParams: { [key: string]: any }): Promise<ToolUseCase[]> {
    const params = Object.assign(
      {
        withoutPagination: true
      },
      listParams
    )
    return this.list(params) as Promise<ToolUseCase[]>
  }

  listByIds(useCaseIds: number[]): Promise<ToolUseCase[]> {
    return this.listUnpaginated({
      include: useCaseIds.join()
    }).then((wpUseCaseRes: ToolUseCase[]) => {
      return wpUseCaseRes
    })
  }

  show(slug: string): Promise<ToolUseCase> {
    return this.catalogueService.showBySlug(
      CatalogueResourceSlug.ToolUseCases,
      slug
    ) as Promise<ToolUseCase>
  }

  store(useCaseDto: ToolUseCaseDto) {
    return this.catalogueService.store(
      CatalogueResourceSlug.ToolUseCases,
      useCaseDto
    )
  }
}
